import { render, staticRenderFns } from "./WaitingForApproval.vue?vue&type=template&id=4e91e58f&scoped=true&"
import script from "./WaitingForApproval.vue?vue&type=script&lang=ts&"
export * from "./WaitingForApproval.vue?vue&type=script&lang=ts&"
import style0 from "./WaitingForApproval.vue?vue&type=style&index=0&id=4e91e58f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e91e58f",
  null
  
)

export default component.exports